import { updateDropdownSelectedValue } from '../utils/helpers';
import { AddToSamplesButton } from '../components/product-samples/add-to-samples-button-component';
import { ToggleQuickshopSidebar } from '../components/product-quickshop/toggle-quickshop-component';

const initialiseArticleSliderSampleButtons = () => {
  const articleProductSliders = document.querySelectorAll(
    '.article-product-slider'
  );

  if (articleProductSliders.length) {
    articleProductSliders.forEach((slider) => {
      const sliderID = slider.getAttribute('id');
      new Vue({
        el: `#${sliderID}`,
        components: {
          'add-to-samples': AddToSamplesButton,
          'toggle-quickshop': ToggleQuickshopSidebar,
        },
        data: {
          ctaButtonIsEnabled: true,
        },
      });
    });
  }
};

const ArticleTemplate = () => {
  if (!$('#blog_article_filter_dropdown').length) {
    return false;
  }

  initialiseArticleSliderSampleButtons();

  let queryString;
  let params;
  let getBlogType = window.localStorage.getItem('blogType');

  $(document).ready(function () {
    // Set Default Local Storage if Null
    // =================================
    if (getBlogType != null) {
      window.localStorage.setItem('blogType', getBlogType);
    } else {
      window.localStorage.setItem('blogType', 'women');
    }

    // Update Get Blog Type Variable
    // =============================
    getBlogType = window.localStorage.getItem('blogType');

    // Update Dropdown
    // ===============
    updateDropdownSelectedValue('blog-article-filter-dropdown', getBlogType);

    // Navigate Back to the Blog Page
    // Based on the Dropdown
    // ==============================
    $('#blog_article_filter_dropdown').on('change', function () {
      let filterVal = $(this).val();
      let blogHandle = window.location.pathname
        .split('/')
        .slice(0, -1)
        .join('/');

      params = ['content=' + filterVal];

      if (params.length > 1) {
        queryString = params.join('&');
      } else {
        queryString = params[0];
      }

      window.localStorage.setItem('blogType', filterVal);
      window.location.href =
        window.location.protocol +
        '//' +
        window.location.host +
        blogHandle +
        '?' +
        queryString;
    });

    let links = $('.article-navigation-banner__navbar__link');
    links.each(function () {
      let link = $(this);
      let url = link.attr('href');
      let updatedLink = `${url}?content=${getBlogType}`;
      $(this).attr('href', updatedLink);
    });

    // Bind Copy URL Function to Icon
    $('.article__copy-url').on('click', function () {
      copyURL();
    });
  });

  // Copy URL for Sharing
  // ====================
  function copyURL() {
    var element = document.getElementById('article-copy-link');
    var successMessage = document.getElementById('article-copy-link-success');
    if (document.body.createTextRange) {
      // ie
      var range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
      document.execCommand('Copy');
      setInterval(function () {
        selection.removeAllRanges();
      }, 1000);
    } else if (window.getSelection) {
      // moz, opera, webkit
      var selection = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(element);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('Copy');
      setInterval(function () {
        selection.removeAllRanges();
      }, 1000);
    }
    setTimeout(() => {
      successMessage.classList.add('is-active');
    }, 500);
    setTimeout(() => {
      successMessage.classList.remove('is-active');
    }, 1800);
  }
};
export default ArticleTemplate;
